var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4943 3.99391C31.3113 4.51807 30.0406 4.87224 28.7047 5.03232C30.0831 4.20753 31.1143 2.9094 31.606 1.38016C30.311 2.14939 28.8936 2.69085 27.4155 2.98099C26.4215 1.91972 25.105 1.21629 23.6703 0.979912C22.2356 0.743538 20.763 0.987446 19.4811 1.67377C18.1992 2.36009 17.1798 3.45042 16.5811 4.77549C15.9823 6.10056 15.8378 7.58622 16.17 9.00182C13.5459 8.87007 10.9788 8.18802 8.63536 6.99994C6.2919 5.81186 4.22445 4.1443 2.56717 2.10549C2.00051 3.08299 1.67467 4.21632 1.67467 5.42332C1.67404 6.5099 1.94162 7.57983 2.45367 8.5382C2.96572 9.49656 3.7064 10.3137 4.61001 10.9172C3.56206 10.8838 2.53724 10.6007 1.62084 10.0912V10.1762C1.62073 11.7002 2.14789 13.1773 3.11285 14.3568C4.07781 15.5364 5.42115 16.3457 6.91492 16.6476C5.94278 16.9107 4.92357 16.9494 3.93426 16.7609C4.35571 18.0722 5.17667 19.2189 6.28219 20.0404C7.38772 20.8619 8.72247 21.3172 10.0996 21.3424C7.76185 23.1776 4.87476 24.173 1.90276 24.1687C1.3763 24.1688 0.850281 24.1381 0.327423 24.0766C3.34418 26.0162 6.85591 27.0457 10.4424 27.0417C22.5833 27.0417 29.2203 16.9862 29.2203 8.26516C29.2203 7.98182 29.2133 7.69566 29.2005 7.41232C30.4915 6.4787 31.6059 5.32259 32.4914 3.99816L32.4943 3.99391Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cb7fb369580d663cac49d567bc05ac38.svg";
export { ForwardRef as ReactComponent };